export default "__VITE_ASSET__BHtqWvdK__"